"use client"

import { AxiosError } from "axios"

function getErrorText(error: unknown): string {
  if (typeof error === "string") return error

  const axiosError = error as AxiosError<{ error?: unknown; message?: unknown }>
  const responseData = axiosError?.response?.data

  if (typeof responseData?.error === "string") return responseData.error
  if (typeof responseData?.message === "string") return responseData.message
  if (error instanceof Error) return error.message

  return ""
}

export function getFriendlyContactCreateError(error: unknown): string {
  const text = getErrorText(error).toLowerCase()

  if (
    text.includes("contacts_email_org_normalized_unique") ||
    (text.includes("duplicate key value") && text.includes("email"))
  ) {
    return "A contact with this email already exists in your organization."
  }

  return getErrorText(error) || "Something went wrong while creating the contact."
}
